/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserListSchema } from './UserListSchema';
import {
    UserListSchemaFromJSON,
    UserListSchemaFromJSONTyped,
    UserListSchemaToJSON,
} from './UserListSchema';

/**
 * 
 * @export
 * @interface WorkspaceMemberSchema
 */
export interface WorkspaceMemberSchema {
    /**
     * 
     * @type {number}
     * @memberof WorkspaceMemberSchema
     */
    id: number;
    /**
     * 
     * @type {UserListSchema}
     * @memberof WorkspaceMemberSchema
     */
    user: UserListSchema;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspaceMemberSchema
     */
    isAdmin: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceMemberSchema
     */
    coreLimit: number;
    /**
     * 
     * @type {number}
     * @memberof WorkspaceMemberSchema
     */
    creditLimit: number;
}

/**
 * Check if a given object implements the WorkspaceMemberSchema interface.
 */
export function instanceOfWorkspaceMemberSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user" in value;
    isInstance = isInstance && "isAdmin" in value;
    isInstance = isInstance && "coreLimit" in value;
    isInstance = isInstance && "creditLimit" in value;

    return isInstance;
}

export function WorkspaceMemberSchemaFromJSON(json: any): WorkspaceMemberSchema {
    return WorkspaceMemberSchemaFromJSONTyped(json, false);
}

export function WorkspaceMemberSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceMemberSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user': UserListSchemaFromJSON(json['user']),
        'isAdmin': json['is_admin'],
        'coreLimit': json['core_limit'],
        'creditLimit': json['credit_limit'],
    };
}

export function WorkspaceMemberSchemaToJSON(value?: WorkspaceMemberSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user': UserListSchemaToJSON(value.user),
        'is_admin': value.isAdmin,
        'core_limit': value.coreLimit,
        'credit_limit': value.creditLimit,
    };
}

